import React from 'react';
import { connect } from 'react-redux'

import { Table, Row, Col, Button, Dropdown, Pagination } from 'antd';
import { SettingOutlined, DownCircleOutlined, DownloadOutlined, CalendarOutlined, EditOutlined, FileOutlined } from '@ant-design/icons';

import { getParamTable } from '../../../../lib/Helper';
import { Link } from 'react-router-dom/cjs/react-router-dom';

class Desktop extends React.Component {

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action
    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  width: '2%',
                }, {
                  title: 'Nama GTK',
                  render: (a, row) => <>{(row.gtk_gelar_depan ? row.gtk_gelar_depan + " " : "") + (row.gtk_nama_lengkap ? row.gtk_nama_lengkap : "-") + (row.gtk_gelar_belakang ? " " + row.gtk_gelar_belakang : "")}<br />NUPTK: {row.nuptk}</>
                }, {
                  title: 'Jadwal Supervisi',
                  dataIndex: 'tgl_evaluasi',
                }, {
                  title: 'Penilai',
                  render: (a, row) => <>{(row.penilai_gelar_depan ? row.penilai_gelar_depan + " " : "") + (row.penilai_nama_lengkap ? row.penilai_nama_lengkap : "-") + (row.penilai_gelar_belakang ? " " + row.penilai_gelar_belakang : "")}</>
                }, {
                  title: 'Nilai PKG',
                  render: (a, row) => <>{row.nilai_akhir ? row.nilai_akhir : "-"}</>,
                }, {
                  title: 'File Instrumen Evaluasi',
                  render: (a, row) => <a target="_blank" rel="noopener noreferrer" href={row.main_path + row.file || ""} style={{ fontSize: 11 }}>Download <DownloadOutlined /></a>,
                }, {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => (!action.detail && !action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.detail ? [{
    key: 0,
    label: <Link to={"/supervisi/pkg/" + row.id}><FileOutlined /> Berkas</Link>
  }] : []), ...(action.update && !row.nilai_akhir ? [{
    key: 1,
    icon: <CalendarOutlined />,
    label: "Atur Jadwal",
    onClick: this.props.modalJadwalEvaluasi.bind(this, true, row)
  }] : []), ...(action.update && row.tgl_evaluasi ? [{
    key: 2,
    icon: <EditOutlined />,
    label: "Nilai Hasil Evaluasi",
    onClick: this.props.modalNilaiEvaluasi.bind(this, true, row)
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>),
                }
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Desktop);
